<!-- Page Header -->
 <app-sub-header-toolbar [title]="'Tele Calling'"></app-sub-header-toolbar>

<!-- <ion-header class="ion-no-border tele-header"> -->
  <div class="tele-page-header">

    <div class="tele-toggle-wrap">
      <div class="tele-tab-strip">
        <button class="tele-tab" [class.tele-tab--active]="selectedValue === 'Contact'" (click)="changeToggle('Contact')">
          <ion-icon name="call-outline"></ion-icon>
          <span>Clients</span>
        </button>
        <button class="tele-tab" [class.tele-tab--active]="selectedValue === 'Employees'" (click)="changeToggle('Employees')">
          <ion-icon name="people-outline"></ion-icon>
          <span>Employees</span>
        </button>
        <button class="tele-tab" [class.tele-tab--active]="selectedValue === 'Calling Leads'" (click)="changeToggle('Calling Leads')">
          <ion-icon name="funnel-outline"></ion-icon>
          <span>Leads</span>
        </button>
      </div>
    </div>
  </div>
<!-- </ion-header> -->

<ion-content>
  <div class="page-responsive tele-calling-page">

    @if (!isDataLoaded) {
    <app-skeleton-emp-team></app-skeleton-emp-team>
    } @else {

    <!-- ── EMPLOYEES VIEW ───────────────────────────── -->
    @if (selectedValue=='Employees') {
    <section class="tele-section">

      <!-- Section heading -->
      <div class="section-heading">
        <div class="section-title-wrap">
          <div class="section-icon-box">
            <ion-icon name="briefcase-outline"></ion-icon>
          </div>
          <div>
            <ion-text class="section-kicker">Team</ion-text>
            <h2 class="section-title">Employee Contacts</h2>
          </div>
        </div>
        <div class="emp-header-actions">
          <span class="tele-action-icon-wrap" matTooltip="Assign numbers to selected employees"
            aria-label="Assign numbers to selected employees" (click)="assignNumbersToMultipleEmployees()">
            <ion-icon name="people-outline"></ion-icon>
          </span>
          <span class="tele-action-icon-wrap" matTooltip="Unassign all numbers from employees"
            aria-label="Unassign all numbers" (click)="unassignAllNumbers()">
            <ion-icon name="person-remove-outline"></ion-icon>
          </span>
        </div>
      </div>

      <!-- Search bar -->
      <div class="emp-search-wrap">
        <ion-searchbar class="tele-search-bar" animated="true" placeholder="Search by name or email"
          [(ngModel)]="searchText"></ion-searchbar>
      </div>

      <ion-card class="surface-card shell-card">
        <ion-card-content>
          @if (employeeList.length > 0) {

          <!-- Select-all bar -->
          <div class="select-all-bar">
            <mat-checkbox [checked]="isAllEmployeesSelected()"
              [indeterminate]="selectedEmployeeIds.length > 0 && !isAllEmployeesSelected()"
              (change)="toggleAllEmployees()" aria-label="Select all employees">
            </mat-checkbox>
            <ion-text class="select-label">Select All</ion-text>
            @if (selectedEmployeeIds.length > 0) {
            <span class="selection-chip">{{ selectedEmployeeIds.length }} selected</span>
            }
          </div>

          <ion-grid class="employee-grid">
            <ion-row>
              @for (item of employeeList | searchUser:searchText; track $index) {
              <ion-col size="12" sizeSm="6" sizeLg="4">
                <ion-card class="info-card" [class.info-card--selected]="isEmployeeSelected(item)">

                  <!-- Top row: checkbox + role badge -->
                  <div class="info-card-top-row">
                    <mat-checkbox [checked]="isEmployeeSelected(item)" (change)="toggleEmployee(item)"
                      (click)="$event.stopPropagation()" aria-label="Select employee">
                    </mat-checkbox>
                    @if (item.UserRoleId==1) {
                    <span class="role-badge role-badge--admin">{{item.UserRole}}</span>
                    } @else if (item.UserRoleId==2) {
                    <span class="role-badge role-badge--lead">{{item.UserRole}}</span>
                    } @else if (item.UserRoleId==3) {
                    <span class="role-badge role-badge--manager">{{item.UserRole}}</span>
                    } @else {
                    <span class="role-badge role-badge--employee">{{item.UserRole}}</span>
                    }
                  </div>

                  <!-- Avatar + name -->
                  <div class="info-card-identity">
                    <div class="emp-avatar">
                      <ion-icon style="color:var(--ion-color-secondary-shade)" name="person-circle-outline"></ion-icon>
                    </div>
                    <!-- <div class="contact-avatar contact-avatar--done">
                          <ion-icon name="person-outline"></ion-icon>
                        </div> -->
                    <div class="info-name-block">
                      <ion-text class="info-primary-text">{{item.Name}}</ion-text>
                      <ion-text class="info-secondary-text">{{item.Email}}</ion-text>
                    </div>
                  </div>

                  <!-- Mobile detail -->
                  <div class="emp-mobile-row">
                    <div class="emp-mobile-icon">
                      <ion-icon name="call-outline"></ion-icon>
                    </div>
                    <ion-text class="detail-value">{{item.Mobileno}}</ion-text>
                  </div>

                  <!-- Stats row -->
                  <div class="contact-stats-row">
                    <button class="stat-pill" [matBadge]="item.ContactCount.All" matBadgeColor="warn"
                      (click)="goToDetail('All', item)">All</button>
                    <button class="stat-pill" [matBadge]="item.ContactCount.Pending" matBadgeColor="accent"
                      (click)="goToDetail('Pending', item)">Pending</button>
                    <button class="stat-pill" [matBadge]="item.ContactCount.Completed" matBadgeColor="primary"
                      (click)="goToDetail('Action Done', item)">Completed</button>
                  </div>

                  <!-- Footer actions -->
                  <div class="info-card-footer">
                    <a href="tel:{{item.Mobileno}}" class="tele-icon-btn tele-icon-btn--call" aria-label="Call employee"
                      matTooltip="Call">
                      <ion-icon name="call"></ion-icon>
                    </a>
                    <button class="tele-action-btn tele-action-btn--primary" (click)="goToDetail('All', item)">
                      <ion-icon name="bar-chart-outline"></ion-icon>
                      View Activity
                    </button>
                    <button class="tele-action-btn tele-action-btn--outline" (click)="resetCallingResponse(item)">
                      <ion-icon name="refresh-outline"></ion-icon>
                      Reset Data
                    </button>
                  </div>

                </ion-card>
              </ion-col>
              }
            </ion-row>
          </ion-grid>

          } @else {
          <app-no-data-found message="No employees found"></app-no-data-found>
          }
        </ion-card-content>
      </ion-card>
    </section>
    }

    <!-- ── CALLING LEADS VIEW ──────────────────────── -->
    @else if (selectedValue == 'Calling Leads') {
    <section class="tele-section">
      <div class="section-heading">
        <div class="section-title-wrap">
          <div class="section-icon-box">
            <ion-icon name="trending-up-outline"></ion-icon>
          </div>
          <div>
            <ion-text class="section-kicker">Leads</ion-text>
            <h2 class="section-title">Calling Leads</h2>
          </div>
        </div>
        <button type="button" class="tele-export-btn" (click)="ExportCallingLeads()">
          <ion-icon name="download-outline"></ion-icon>
          Export Leads
        </button>
      </div>

      <ion-card class="surface-card shell-card">
        <ion-card-content>
          @if (callingLeadsList.length > 0) {
          <ion-grid>
            <ion-row>
              @for (item of callingLeadsList; track $index) {
              <ion-col size="12" sizeSm="6" sizeMd="6" sizeLg="4">
                <ion-card class="info-card lead-card">
                  <!-- Card header strip -->
                  <div class="lead-card-header">
                    <div class="tele-icon-wrap">
                      <ion-icon name="person-outline"></ion-icon>
                    </div>
                    <div class="lead-header-copy">
                      <ion-text class="info-primary-text">{{item.ContactName}}</ion-text>
                      <ion-text class="info-secondary-text">Created by: {{item.CreatedBy}}</ion-text>
                    </div>
                    <span class="tele-chip">{{item.KeyWith}}</span>
                  </div>

                  <!-- Details grid -->
                  <div class="lead-details-grid">
                    <div class="lead-detail-cell">
                      <ion-text class="detail-label">Contact No</ion-text>
                      <ion-text class="detail-value">{{item.ContactMobile}}</ion-text>
                    </div>
                    <div class="lead-detail-cell">
                      <ion-text class="detail-label">Email</ion-text>
                      <ion-text class="detail-value">{{item.ContactEmail}}</ion-text>
                    </div>
                    <div class="lead-detail-cell">
                      <ion-text class="detail-label">Estate Type</ion-text>
                      <ion-text class="detail-value">{{item.EstateType}}</ion-text>
                    </div>
                    <div class="lead-detail-cell">
                      <ion-text class="detail-label">Deal In</ion-text>
                      <ion-text class="detail-value">{{item.DealingType}}</ion-text>
                    </div>
                    <div class="lead-detail-cell">
                      <ion-text class="detail-label">Property Type</ion-text>
                      <ion-text class="detail-value">{{item.PropertyType}}</ion-text>
                    </div>
                    <div class="lead-detail-cell">
                      <ion-text class="detail-label">Preferred Area</ion-text>
                      <ion-text class="detail-value">{{item.Area}}</ion-text>
                    </div>
                    <div class="lead-detail-cell">
                      <ion-text class="detail-label">BHK Type</ion-text>
                      <ion-text class="detail-value">{{item.BHKTypeId ? item.BHKType : 'Not Specified'}}</ion-text>
                    </div>
                    <div class="lead-detail-cell">
                      <ion-text class="detail-label">Furnished</ion-text>
                      <ion-text class="detail-value">{{item.FurnishedTypeId ? item.FurnishedType : 'Not
                        Specified'}}</ion-text>
                    </div>
                    <div class="lead-detail-cell lead-detail-cell--full">
                      <ion-text class="detail-label">Budget Range</ion-text>
                      <ion-text class="detail-value">{{item.BudgetRangeFrom}} – {{item.BudgetRangeTo}}</ion-text>
                    </div>
                    @if (item.PropDesc) {
                    <div class="lead-detail-cell lead-detail-cell--full">
                      <ion-text class="detail-label">Remark</ion-text>
                      <ion-text class="detail-value">{{item.PropDesc}}</ion-text>
                    </div>
                    }
                  </div>

                  <!-- Footer actions -->
                  <div class="info-card-footer">
                    <a href="tel:{{item.ContactMobile}}" class="tele-icon-btn tele-icon-btn--call">
                      <ion-icon name="call"></ion-icon>
                    </a>
                    <button class="tele-action-btn tele-action-btn--danger" (click)="deleteLead(item.Id)">
                      <ion-icon name="trash-outline"></ion-icon>
                      Delete
                    </button>
                  </div>
                </ion-card>
              </ion-col>
              }
            </ion-row>
          </ion-grid>
          } @else {
          <app-no-data-found message="No leads found"></app-no-data-found>
          }
        </ion-card-content>
      </ion-card>
    </section>
    }

    @else {
    <section class="tele-section">

      <!-- Stat summary strip -->
      <div class="contact-stat-strip">
        <div class="contact-stat-item">
          <ion-text class="contact-stat-value">{{AllContactCount}}</ion-text>
          <ion-text class="contact-stat-label">Total</ion-text>
        </div>
        <div class="contact-stat-divider"></div>
        <div class="contact-stat-item">
          <ion-text class="contact-stat-value contact-stat-value--warn">{{ActionPendingCount}}</ion-text>
          <ion-text class="contact-stat-label">Pending</ion-text>
        </div>
        <div class="contact-stat-divider"></div>
        <div class="contact-stat-item">
          <ion-text class="contact-stat-value contact-stat-value--success">{{ActionTakenCount}}</ion-text>
          <ion-text class="contact-stat-label">Action Taken</ion-text>
        </div>
        <div class="contact-stat-divider"></div>
        <div class="contact-stat-item">
          <ion-text class="contact-stat-value contact-stat-value--info">{{AssignContactCount}}</ion-text>
          <ion-text class="contact-stat-label">Assigned</ion-text>
        </div>
        <div class="contact-stat-divider"></div>
        <div class="contact-stat-item">
          <ion-text class="contact-stat-value contact-stat-value--muted">{{AssignPendingCount}}</ion-text>
          <ion-text class="contact-stat-label">Assign Pending</ion-text>
        </div>
      </div>

      <ion-card class="surface-card shell-card tab-shell-card">
        <ion-card-content>
          <mat-tab-group class="contact-tab-group" mat-stretch-tabs="false" mat-align-tabs="start"
            (selectedTabChange)="onTabChanged($event)">

            <!-- ── Tab 1: Action Pending ──────────────── -->
            <mat-tab>
              <ng-template mat-tab-label>
                <div class="tab-label-wrap">
                  <span class="tab-label-icon tab-label-icon--pending">
                    <ion-icon name="time-outline"></ion-icon>
                  </span>
                  <span>Action Pending</span>
                </div>
              </ng-template>

              <!-- Bulk-action bar -->
              <div class="tab-bulk-bar">
                <div class="tab-bulk-left">
                  <mat-checkbox (change)="$event ? toggleAllRows() : null"
                    [checked]="selection.hasValue() && isAllSelected()" [aria-label]="checkboxLabel()">
                  </mat-checkbox>
                  <span class="tab-bulk-label">
                    @if (selectedList.length > 0) {
                    <strong>{{selectedList.length}}</strong> selected
                    } @else {
                    Select all
                    }
                  </span>
                </div>
                <div class="tab-bulk-right">
                  @if (selectedList.length > 0) {
                  <button class="tele-action-btn tele-action-btn--primary" (click)="assignNumber()">
                    <ion-icon name="person-add-outline"></ion-icon>
                    Assign
                  </button>
                  } @else {
                  <button class="tele-menu-btn" matIconButton [matMenuTriggerFor]="menu">
                    <mat-icon>more_vert</mat-icon>
                  </button>
                  <mat-menu #menu="matMenu">
                    <button mat-menu-item (click)="importContact()">
                      <mat-icon>cloud_upload</mat-icon>
                      <span>Import number</span>
                    </button>
                    <button mat-menu-item (click)="downloadSampleFile()">
                      <mat-icon>cloud_download</mat-icon>
                      <span>Download sample file</span>
                    </button>
                  </mat-menu>
                  }
                </div>
              </div>

              @if (!dataSource || dataSource.data.length === 0) {
              <app-no-data-found message="No numbers found"></app-no-data-found>
              }
              <ion-grid>
                <ion-row>
                  @for (item of (dataSource?.data || []); track $index) {
                  <ion-col size="12" sizeSm="6" sizeLg="4">
                    <ion-card class="info-card contact-card contact-card--pending"
                      [class.info-card--selected]="selection.isSelected(item)">

                      <div class="info-card-top-row">
                        <mat-checkbox (click)="$event.stopPropagation()"
                          (change)="$event ? selection.toggle(item) : null" [checked]="selection.isSelected(item)"
                          [aria-label]="checkboxLabel(item)" (change)="selectSignleValue($event)" [value]="item.Id">
                        </mat-checkbox>
                        <div class="contact-status-badge contact-status-badge--pending">
                          <ion-icon name="time-outline"></ion-icon>
                          <span>Pending</span>
                        </div>
                      </div>

                      <!-- Identity -->
                      <div class="info-card-identity">
                        <div class="contact-avatar">
                          <ion-icon name="person-outline"></ion-icon>
                        </div>
                        <div class="info-name-block">
                          <ion-text class="info-primary-text">{{item.Name}}</ion-text>
                          <div class="contact-mobile-row">
                            <ion-icon name="call-outline"></ion-icon>
                            <ion-text class="info-secondary-text">{{item.MobileNumber}}</ion-text>
                          </div>
                        </div>
                      </div>

                      <!-- Footer actions -->
                      <div class="info-card-footer">
                        @if (isExpired) {
                        <button class="tele-icon-btn tele-icon-btn--whatsapp"
                          (click)="$event.stopPropagation(); whatsAppMessages(item.MobileNumber)" aria-label="WhatsApp"
                          matTooltip="Send WhatsApp">
                          <ion-icon name="logo-whatsapp"></ion-icon>
                        </button>
                        <a href="tel:{{item.MobileNumber}}" (click)="$event.stopPropagation()"
                          class="tele-icon-btn tele-icon-btn--call" aria-label="Call" matTooltip="Call">
                          <ion-icon name="call"></ion-icon>
                        </a>
                        <button class="tele-icon-btn tele-icon-btn-delete"
                          (click)="$event.stopPropagation(); deleteUser(item.Id)" matTooltip="Delete contact"
                          aria-label="Delete contact">
                          <ion-icon name="trash-outline"></ion-icon>
                        </button>
                        <button class="tele-action-btn tele-action-btn--primary contact-take-action"
                          (click)="$event.stopPropagation(); takeAction(item.Id, item.Response)">
                          <ion-icon name="checkmark-circle-outline"></ion-icon>
                          Take Action
                        </button>
                        } @else {
                        <button class="tele-icon-btn tele-icon-btn--whatsapp"
                          (click)="$event.stopPropagation(); goToSubscription()" aria-label="WhatsApp"
                          matTooltip="Upgrade to use WhatsApp">
                          <ion-icon name="logo-whatsapp"></ion-icon>
                        </button>
                        <button class="tele-icon-btn tele-icon-btn--call"
                          (click)="$event.stopPropagation(); goToSubscription()" aria-label="Call"
                          matTooltip="Upgrade to call">
                          <ion-icon name="call"></ion-icon>
                        </button>
                        <button class="tele-action-btn tele-action-btn--primary contact-take-action"
                          (click)="$event.stopPropagation(); goToSubscription()">
                          <ion-icon name="checkmark-circle-outline"></ion-icon>
                          Take Action
                        </button>
                        }
                      </div>
                    </ion-card>
                  </ion-col>
                  }
                </ion-row>
              </ion-grid>
            </mat-tab>

            <!-- ── Tab 2: Action Done ─────────────────── -->
            <mat-tab>
              <ng-template mat-tab-label>
                <div class="tab-label-wrap">
                  <span class="tab-label-icon tab-label-icon--done">
                    <ion-icon name="checkmark-circle-outline"></ion-icon>
                  </span>
                  <span>Action Done</span>
                </div>
              </ng-template>

              <!-- Search bar -->
              <div class="done-search-row">
                <div class="tele-search-wrapper">
                  <ion-searchbar type="number" class="tele-search-bar" animated="true" inputmode="numeric"
                    pattern="[0-9]*" placeholder="Enter contact number to find" [maxlength]="10"
                    [(ngModel)]="searchContactText" (ionInput)="onSearchTextChange($event)">
                  </ion-searchbar>
                  <button class="tele-search-btn" [disabled]="!searchContactText" (click)="searchContactNumber()">
                    <ion-icon name="search"></ion-icon>
                  </button>
                </div>
              </div>

              <!-- Bulk-action bar -->
              <div class="tab-bulk-bar">
                <div class="tab-bulk-left">
                  <mat-checkbox (change)="$event ? toggleAllRows() : null"
                    [checked]="selection.hasValue() && isAllSelected()" [aria-label]="checkboxLabel()">
                  </mat-checkbox>
                  <span class="tab-bulk-label">
                    @if (selectedList.length > 0) {
                    <strong>{{selectedList.length}}</strong> selected
                    } @else {
                    Select all
                    }
                  </span>
                </div>
                <div class="tab-bulk-right">
                  @if (dataSource?.data?.length > 0) {
                  <button class="tele-action-btn tele-action-btn--outline" (click)="exportContactResponse()">
                    <ion-icon name="download-outline"></ion-icon>
                    Export Response
                  </button>
                  }
                </div>
              </div>

              @if (!dataSource || dataSource.data.length === 0) {
              <app-no-data-found message="No numbers found"></app-no-data-found>
              }
              <ion-grid>
                <ion-row>
                  @for (item of (dataSource?.data || []); track $index) {
                  <ion-col size="12" sizeSm="6" sizeLg="4">
                    <ion-card class="info-card contact-card contact-card--done"
                      [class.info-card--selected]="selection.isSelected(item)">

                      <div class="info-card-top-row">
                        <mat-checkbox (click)="$event.stopPropagation()"
                          (change)="$event ? selection.toggle(item) : null" [checked]="selection.isSelected(item)"
                          [aria-label]="checkboxLabel(item)" (change)="selectSignleValue($event)" [value]="item.Id">
                        </mat-checkbox>
                        <div class="contact-status-badge contact-status-badge--done">
                          <ion-icon name="checkmark-circle-outline"></ion-icon>
                          <span>Done</span>
                        </div>
                      </div>

                      <!-- Identity -->
                      <div class="info-card-identity">
                        <div class="contact-avatar contact-avatar--done">
                          <ion-icon name="person-outline"></ion-icon>
                        </div>
                        <div class="info-name-block">
                          <ion-text class="info-primary-text">{{item.Name}}</ion-text>
                          <div class="contact-mobile-row">
                            <ion-icon name="call-outline"></ion-icon>
                            <ion-text class="info-secondary-text">{{item.MobileNumber}}</ion-text>
                          </div>
                        </div>
                      </div>

                      <!-- Response details -->
                      <div class="contact-response-block">
                        <div class="contact-response-row">
                          <div class="contact-response-cell">
                            <ion-text class="detail-label">Updated By</ion-text>
                            <ion-text class="detail-value">{{item.UpdatedBy || 'Updated by you'}}</ion-text>
                          </div>
                          <div class="contact-response-cell">
                            <ion-text class="detail-label">Response</ion-text>
                            <span class="response-tag">{{item.Response}}</span>
                          </div>
                        </div>
                        @if (item.Comment) {
                        <div class="contact-response-comment">
                          <ion-icon name="chatbubble-outline"></ion-icon>
                          <ion-text class="detail-value">{{item.Comment}}</ion-text>
                        </div>
                        }
                        <div class="contact-response-date">
                          <ion-icon name="calendar-outline"></ion-icon>
                          <ion-text class="detail-value">{{item.ResponseDateTime | date:'MMM d, y · h:mm a'}}</ion-text>
                        </div>
                      </div>

                      <!-- Footer actions -->
                      <div class="info-card-footer">
                        <a href="tel:{{item.MobileNumber}}" (click)="$event.stopPropagation()"
                          class="tele-icon-btn tele-icon-btn--call" aria-label="Call" matTooltip="Call">
                          <ion-icon name="call"></ion-icon>
                        </a>
                        <button class="tele-icon-btn tele-icon-btn-delete"
                          (click)="$event.stopPropagation(); deleteUser(item.Id)" matTooltip="Delete Contact"
                          aria-label="Delete contact">
                          <ion-icon name="trash-outline"></ion-icon>
                        </button>
                        <button class="tele-action-btn tele-action-btn--outline contact-take-action"
                          (click)="$event.stopPropagation(); takeAction(item.Id, item.Response)">
                          <ion-icon name="refresh-outline"></ion-icon>
                          Action Again
                        </button>
                      </div>
                    </ion-card>
                  </ion-col>
                  }
                </ion-row>
              </ion-grid>

              @if (tabIndex != 0) {
              <ion-infinite-scroll threshold="100px" (ionInfinite)="loadMoreData($event)">
                <ion-infinite-scroll-content loadingSpinner="bubbles" loadingText="Loading more data...">
                </ion-infinite-scroll-content>
              </ion-infinite-scroll>
              }
            </mat-tab>

          </mat-tab-group>
        </ion-card-content>
      </ion-card>
    </section>
    }

    }
  </div>
</ion-content>